<template>
    <section>
        <v-container class="nav">
            <v-btn icon class="black--text" @click="$router.go(-1)">
                <v-icon>{{ mdiArrowLeft }}</v-icon>
            </v-btn>
            <v-card-title>
                <v-avatar
                    v-if="screen_width > 535"
                    class="page-icon teal mr-2 elevation-5"
                >
                    <v-icon large class="white--text">
                        {{ mdiPaperclip }}
                    </v-icon>
                </v-avatar>
                <h2 style="word-break: normal;">
                    Annual Check Up Request
                </h2>
            </v-card-title>
            <v-divider />
        </v-container>
        <div class="main">
            <PersonalInformation :get-info="getInfo" />
            <AccountInformation :get-info="getInfo" />
            <v-form ref="form" @submit.prevent="submit">
                <ACUForm
                    :data="data"
                    :location="location"
                />
                <p style="text-align: center; margin: auto; height: 70px; vertical-align: middle;">
                    <v-btn
                        large
                        style="margin: 0 auto; font-weight: 600; font-size: 18px;"
                        class="teal white--text"
                        :loading="loading"
                        type="submit"
                    >
                        Submit
                    </v-btn>
                </p>
            </v-form>
        </div>
    </section>
</template>

<script>
import { moment } from '../../../../utils/date-shim'
import PersonalInformation from './PersonalInformation.vue'
import AccountInformation from './AccountInformation.vue'
import ACUForm from './ACUForm.vue'
import { mapActions, mapGetters } from 'vuex'
import ClientPortal from './../../../../plugins/axios'
import { mdiArrowLeft, mdiPaperclip } from '@mdi/js'

export default {
    components: {
        PersonalInformation, AccountInformation, ACUForm
    },
    data: ()=>({
        mdiArrowLeft, 
        mdiPaperclip,
        valid: false,
        data: {
            menu: false,
            facility: null,
            selectedDate: ''
        },
        location: {
            region: '',
            province: '',
            city: ''
        },
        loading: false,
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['getUserConsultInfo']),
        getInfo: {
            get() {
                return {
                    ACCOUNT: this.getUserConsultInfo.ACCOUNT,
                    EFF_DATE: moment(this.getUserConsultInfo.EFF_DATE).utcOffset('+0800').format('DD MMMM YYYY'),
                    ACC_EXP: moment(this.getUserConsultInfo.ACC_EXP).utcOffset('+0800').format('DD MMMM YYYY'),
                    PD_UNTIL: moment(this.getUserConsultInfo.PD_UNTIL).utcOffset('+0800').format('DD MMMM YYYY'),
                    LAST_D: moment(this.getUserConsultInfo.LAST_D).utcOffset('+0800').format('DD MMMM YYYY'),
                    MSU: this.getUserConsultInfo.MSU,
                    STATUS: this.getUserConsultInfo.STATUS,
                    NAME: this.getUserConsultInfo.NAME,
                    SEX: this.getUserConsultInfo.SEX,
                    DOB: moment(this.getUserConsultInfo.DOB).utcOffset('+0800').format('DD MMMM YYYY'),
                    F_BIRTHDATE: this.getUserConsultInfo.F_BIRTHDATE
                }
            }
        }
    },
    async created() {
        this.toRegions()
        this.toProvinces({
            REGION: this.location.region
        })
        this.toCities({
            REGION: this.location.region,
            PROVINCE: this.location.province
        })
        this.userConsult({
            MEMBN: this.$cookies.get('usermembn')
        })
        this.additionalClinics({
            MEMBN: this.$cookies.get('usermembn'),
            FILTER: {
                REGION: this.location.region,
                PROVINCE: this.location.province,
                CITY: this.location.city
            }
        })
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['getCsrfToken', 'userConsult', 'verifyACU', 'additionalClinics', 'toRegions', 'toProvinces', 'toCities']),
        submit() {
            // Submit button method
            this.$nextTick(async () => {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    // Do your submit stuff
                    let payload = {
                        MEMBN: this.$cookies.get('usermembn'),
                        CLINIC_NAME: this.data.facility.hosp_name,
                        CLINIC_CODE: this.data.facility.hosp_msu_code,
                        TARGET_DATE: this.data.selectedDate
                    }
                    await ClientPortal
                        .post(`${process.env.VUE_APP_API}/login/consultation/eligibleAPE`,
                              { MEMBN: this.$cookies.get('usermembn') }, { withCredentials : true }
                        )
                        .then(async (response) => {
                            if(response.status == 200 && response.data.eligible == true) {
                                await this.verifyACU(payload)
                            } else {
                                this.$router.push('/dashboard/annual-physical-exam/main/')
                            }
                        })
                        .catch(() => {
                            // console.log("Error: ", error)
                        })
                }
            })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>

<style scoped>
section {
    padding: 0 20px;
    width: 100%;
    background-image: url("./../../../../assets/dashboardBG.webp");
    background-position: center;
    background-size: cover;
}
.main {
    max-width: 1750px;
    margin: 0 auto;
}
@media (max-width: 390px) {
    .page-icon {
        display: none;
    }
    .main {
        max-width: 300px;
        margin: 0 auto;
    }
}
@media (min-width: 391px) and (max-width: 599px) {
    /* Navbar */
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
    .main {
        max-width: 600px;
        margin: 0 auto;
    }
}
@media (min-width: 600px) and (max-width: 968px) {
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
    .main {
        max-width: 1200px;
        margin: 0 auto;
    }
}
@media (min-width: 969px) and (max-width: 1264px) {
    /* Navbar */
    .nav {
        margin-top: 60px;
    }
    .nav h2 {
        font-size: 25px;
    }
    .main {
        max-width: 870px;
        margin: 0 auto;
    }
}
</style>
